// extracted by mini-css-extract-plugin
var _1 = "ProfileDocumentsWidget-moduledivider__dXivu Divider-moduleDivider__dL3Vg";
export { _1 as "divider" }
